import { Directive, TemplateRef, ViewContainerRef, Input } from '@angular/core';
import { IfFeatureService } from '../../services/if-feature/if-feature.service';

@Directive({
  selector: '[tdWbIfNoFeature]'
})
export class IfNoFeatureDirective {
  private hasView: boolean = false;

  constructor(private viewContainer: ViewContainerRef,
              private templateRef: TemplateRef<unknown>,
              private ifFeatureService: IfFeatureService) {}

  @Input()
  set tdWbIfNoFeature(key: string) {
    const featureFlag = this.ifFeatureService.getFeatureFlag<boolean>(key);
    const shouldShow = !(featureFlag ?? false);
    if (shouldShow && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!shouldShow && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }
}
